const cafeOrderService = "/Order"

export function orderService (http) {
    return {
        getAllPeronnelOrders: async (userId,pageNumber, pageSize, sortBy, filters) => {
            const newSort = (sortBy || []).map(item => ({
                member: item.id,
                sortDirection: item.desc ? "Descending" : "Ascending"
            }));
            const filter=filters;
            const parameters = {
                userId,
                dataAttribute:{
                    page:pageNumber,
                    pageSize,
                    sorts: newSort.lenght==0?[{member:"Id",sortDirection:"Ascending"}]:newSort,
                    filter: filter
                }                
            }
            return (await http.post(cafeOrderService + '/GetAllPersonnelOrdersAsync', parameters));
        }    
    }
}